import classes from "./styles.module.scss";

type IProps = {
	color?: "default" | "blue";
};

export default function RoadmapDot({ color = "default" }: IProps) {
	return <div className={classes["root"]} data-color={color} />;
}
